import Vue from 'vue'
import Vuex from 'vuex'

/*module模块化*/
import home from './module/home'
import login from './module/login'
import book from './module/book'
import manual from './module/manual'

Vue.use(Vuex);
export const store = new Vuex.Store({
  modules: {
    login,
    home,
    book,
    manual
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js